module.exports = __webpack_public_path__ + "static/media/signal-slash.f2697d28.svg";